module.exports = __webpack_public_path__ + "img/prod-hob.7eff064e.jpg";